import { AllocationExperimentFormValues } from './interfaces';

export enum ExperimentStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED'
}

export const defaultValues: AllocationExperimentFormValues = {
  name: '',
  details: '',
  status: ExperimentStatus.ACTIVE
};

export enum VALIDATION_MESSAGE {
  EXPERIMENT_NAME_MESSAGE = 'Please enter a valid name',
  EXPERIMENT_DETAILS_MESSAGE = 'Please enter valid details',
  EXPERIMENT_FILE_MESSAGE = 'Please upload a file'
}

export const ExperimentStatusMap: Record<ExperimentStatus, string> = {
  [ExperimentStatus.ACTIVE]: 'Active',
  [ExperimentStatus.INACTIVE]: 'Inactive',
  [ExperimentStatus.DELETED]: 'Deleted'
};

export const sampleExperimentFile = 'loan_account_number\n' + '01000000\n' + '02000000\n';
